import { useState, useRef, useEffect } from "react";
import "./App.css";
import Chapter from "./components/chapter/Chapter";
import data from "./DummyData";
import anime from "animejs/lib/anime.es.js";

function App() {
  console.log(data);
  const [chapter, setChapter] = useState(
    data.filter((obj) => {
      return obj.id === 1;
    })
  );

  const animationRef = useRef();
  useEffect(() => {
    animationRef.current = anime({
      targets: ".chapter-data",
      opacity: [0, 1],
      delay: 0,
      loop: false,
      direction: "alternate",
      easing: "easeInOutSine",
    });
  }, []);

  return (
    <div className="App">
      <header>
        <h1>
          Here's What You Can Expect For 1000s Of Leads. <br /> In Seconds.
          Using AI
        </h1>
      </header>
      <div className="container-fluid">
        <div className="row">
          <div
            className="ch-name col-4 col-sm-2 col-md-2"
            onClick={() => {
              setChapter(
                data.filter((obj) => {
                  return obj.id === 1;
                })
              );
              animationRef.current.restart();
            }}
          >
            Linked In Personalisation
          </div>
          <div
            className="ch-name col-4 col-sm-2 col-md-2"
            onClick={() => {
              setChapter(
                data.filter((obj) => {
                  return obj.id === 2;
                })
              );
              animationRef.current.restart();
            }}
          >
            Personalised Icebreakers
          </div>
          <div
            className="ch-name col-4 col-sm-2 col-md-2"
            onClick={() => {
              setChapter(
                data.filter((obj) => {
                  return obj.id === 3;
                })
              );
              animationRef.current.restart();
            }}
          >
            BackLink Personalisations
          </div>
          <div
            className="ch-name col-4 col-sm-2 col-md-2"
            onClick={(e) => {
              setChapter(
                data.filter((obj) => {
                  return obj.id === 4;
                })
              );
              animationRef.current.restart();
            }}
          >
            Contextaul Pitches
          </div>
        </div>
      </div>
      <Chapter className="jumbotron" chapter={chapter} key={chapter.id} />
    </div>
  );
}

export default App;
